<template>
  <v-form
  class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">Import Certificate</h3>
    <p class="text-caption mb-4">Importá un certificado a un keystore/perfil destino.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="validate">
        Import Certificate >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-autocomplete
            v-model="selectKeystore"
            :items="keystoresOPTIONS"
            item-title="id"
            item-value="id"
            label="Target keyStoreId"
        ></v-autocomplete>
        <v-autocomplete
            v-model="selectProfile"
            :items="profileOPTIONS"
            item-title="friendlyName"
            item-value="name"
            label="Target Profile"
        ></v-autocomplete>
        <v-autocomplete
            v-model="selectSecPolTmpl"
            :items="secPolTmplOPTIONS"
            label="SecPolTmpl"
        ></v-autocomplete>
        <v-textarea
            no-resize
            v-model="localCertificateToImport"
            height="100px"
            name="certificate"
            label="Certificate To Import"
        ></v-textarea>
      </v-col>
      <v-col md="6">
        <v-textarea
            name="parameters"
            label="Parameters"
            no-resize
            height="150px"
            v-model="requestPayload"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <v-textarea
            name="response"
            label="Response"
            auto-grow
            v-model="response"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
  export default {
    props:["data", "config", "certificateToImport"],
    data: () => ({
      valid: true,
      requestPayload: '{}',
      response: '',
      localCertificateToImport:'{"keyStoreId":"PFX","profileName":"-Select-"}',
      selectKeystore:"",
      selectSecPolTmpl:"",
      selectProfile:"",
      keystoresOPTIONS:[],
      secPolTmplOPTIONS:[],
      profileOPTIONS:[],
      itemskeyOptions: [
          '1024','2048','4096'
      ],
    }),
    mounted(){
      if (this.config) {
        this.localCertificateToImport = JSON.parse(this.config.certificateToImport)
        this.keystoresOPTIONS = this.config.keyStoreIds
        this.selectKeystore = this.config.keyStore
        this.profileOPTIONS = this.config.profileOPTIONS
        this.selectProfile = this.config.profile
        this.secPolTmplOPTIONS = this.config.secPolTmplOPTIONS
        this.selectSecPolTmpl = this.config.selectSecPolTmpl
				this.updateRequest('certificateToImport', null , JSON.parse(this.config.certificateToImport))
      }
      this.listKeystores();
      this.keystoresOPTIONS = this.objectToArray(this.data.keystoresOPTIONS)
    },

    watch: {
      selectKeystore(value){
        this.updateRequest('keyStore','id',value)
        let securityPolicyList = this.setSecurityPolicyOptions(value)
        this.secPolTmplOPTIONS = this.objectToArray(this.data[securityPolicyList])
        this.getKeyStoreInfo(value)
      },
      selectSecPolTmpl(value){
        this.updateRequest('securityPolicy',null,JSON.parse(value))
      },
      selectProfile(value){
        this.updateRequest('keyStore','profile',value)
      },
      localCertificateToImport(value){
        this.updateRequest('certificateToImport', null , JSON.parse(value))
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      setSecurityPolicyOptions(keyStore){
        let response
        switch (keyStore) {
          case "WIN-ENH":
            response = 'securityPolicyCAPI'
            break;

          case "CSK":
            response = 'securityPolicyCSK'
          break;

          case "PFX":
            response = 'securityPolicyPFX'
          break;

          case "MACOS" || "FF-NSS":
            response = 'securityPolicyEMPTY'
          break;

          default:
            response = 'securityPolicyDEVICE'
            break;
        }
        return response
      },
      updateRequest(key1, key2, param){
        let request = JSON.parse(this.requestPayload)
        if(key2){
          if(!request[key1]) request[key1] = {}
          request[key1][key2] = param;
        }else{
          request[key1] = param;
        }
        this.requestPayload = JSON.stringify(request, null, "\t");
      },
      objectToArray(objectValue){
        let newArray = []
        Object.keys(objectValue).forEach(element => {
          newArray.push({text: objectValue[element], value: element})
        });
        return newArray
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          this.importCertificate()
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

      importCertificate() {
        let request = JSON.parse(this.requestPayload)
        console.log(request);
        if (request.keyStore?.id) {
          alisonJS.importCertificate(request).then((certificate)=>{
                this.response = JSON.stringify(certificate);
                this.setColor('success')
                this.setSnack('Certificate imported successfully')
          }, (e)=> {
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = JSON.stringify(e, null, "\t");
            })
        } else {
          alert('All fields are required')
        }
      },

      getKeyStoreInfo(keystoreId) {
        this.profileOPTIONS = []
        alisonJS.keyStoreInfo({id:keystoreId}).then((info) => {
              this.setColor('info')
              this.setSnack('KeyStore info obtained successfully')
              this.profileOPTIONS.push({friendlyName: 'new profile', name:''})
              info.keyStores.forEach(ks => {
                  this.profileOPTIONS = this.profileOPTIONS.concat(ks.profiles)
                });
          }).catch(e=>{
              this.setColor('error')
              this.setSnack('FAILURE: ' + JSON.stringify(e))
          })
      },

      listKeystores() {
        alisonJS.listKeyStores().then((list) => {
          console.log(list)
              this.keystoresOPTIONS = list.keyStores.filter((key)=>key.capabilities.includes('I'));
              this.setColor('success')
              this.setSnack('KeyStores obtained successfully')
          }).catch((e)=>{
            console.log("error:", e)
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
